import { render, staticRenderFns } from "./OrderStatusForm.vue?vue&type=template&id=f9fa940e&scoped=true&"
import script from "./OrderStatusForm.vue?vue&type=script&lang=js&"
export * from "./OrderStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fa940e",
  null
  
)

export default component.exports